import { Spinner, SpinnerSize } from './Spinner';
import { useTranslation } from 'react-i18next';

interface LoadingStateProps {
  title?: string;
  subtitle?: string;
  spinnerSize?: SpinnerSize;
  className?: string;
  textClassName?: string;
  spinnerClassName?: string;
}

export function LoadingState({
  title,
  subtitle,
  spinnerSize = 'lg',
  className = '',
  textClassName = 'text-gray-600',
  spinnerClassName = 'text-brand-300',
}: LoadingStateProps) {
  const { t } = useTranslation('common');

  return (
    <div
      className={`flex flex-col items-center justify-center py-12 ${className}`}
      role="status"
      aria-live="polite"
    >
      <Spinner size={spinnerSize} className={spinnerClassName} decorative />
      {title !== '' ? <p className={`mt-3 text-sm ${textClassName}`}>{title ?? t('loading')}</p> : null}
      {subtitle ? <p className="mt-2 text-xs text-gray-400">{subtitle}</p> : null}
    </div>
  );
}
